import React from 'react'
import Image from 'next/image'

import { Column } from '@/components/layout'
import moneyBackImg from '@/assets/buy-flow/right-side/cc--money-back.png'
import taxImg from '@/assets/buy-flow/right-side/cc--tax.png'
import communityImg from '@/assets/buy-flow/right-side/cc--community.png'

import styles from './CheckoutSideCreditCard.module.scss'

export default function CheckoutSideCreditCard() {
  return (
    <Column className={styles.background} gap={32} size={66}>
      <h1 className={styles.headLine}>You're Almost Ready to<br /> Start with Neat</h1>
      <ul className={styles.featuresList}>
        <li>
          <Image alt="" src={moneyBackImg} />
          We offer a full 30-day money-back guarantee should Neat not be the right solution for you.
        </li>
        <li>
          <Image alt="" src={taxImg} />
          The cost of Neat is tax-deductible for businesses and those who are self-employed.
        </li>
        <li>
          <Image alt="" src={communityImg} />
          Over 2 million small businesses have trusted Neat services, and hundreds of millions of people have been touched by Neat businesses. Join the community and get Neat!
        </li>
      </ul>
    </Column>
  )
}
